<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important;height: auto !important;padding: 20px 0px 26px 0px;">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/snake.svg" style="height: 10rem !important"/>
                <div class="mt-5 px-4 text-left fs-14">
                    <div class="mb-4 text-black fw-600 text-center" style="font-size: 25px;">Alert!</div>
                    <div class="p-3" style="border: 1px solid #707070;border-radius: 6px;">
                        You are logged in from the {{loggedInUser.company_name}} account and the Report is being shared with a few members outside your company
                        <span v-if="user_data.length > 0">{{user_data[0].email || "-"}}
                        <span v-if="user_data.length > 1">,</span>
                        <span v-if="user_data.length > 1">{{user_data[1].email || "-"}} </span>
                        </span>
                        <el-popover v-if="user_data.length > 2" placement="bottom"  trigger="hover">
                            <div v-for="(email,index) in user_data" :key="index">
                                <span class="fw-500">{{email.email}}</span>
                            </div>
                            <el-button slot="reference" class="pl-0 pr-0 button-back">
                                <div class="fw-500  mt-4px text-center text-secondary">
                                    +{{user_data.length - 2}} more
                                </div>
                            </el-button>
                        </el-popover>
                        <span v-if="user_data_email.length > 0 && user_data.length > 0">{{","}}</span>
                        <span v-if="user_data_email.length > 0">{{user_data_email[0].email_id }}
                        <span v-if="user_data_email.length > 1">,</span>
                        <span v-if="user_data_email.length > 1">{{user_data_email[1].email_id }} </span>
                        </span>
                        <el-popover v-if="user_data_email.length > 2" placement="bottom"  trigger="hover">
                            <div v-for="(email,index) in user_data_email" :key="index">
                                <span class="fw-500">{{email.email_id}}</span>

                            </div>
                            <el-button slot="reference" class="pl-0 pr-0 button-back">
                                <div class="fw-500  mt-4px text-center text-secondary">
                                    +{{user_data_email.length - 2}} more
                                </div>
                            </el-button>
                        </el-popover>
                        <span v-if="other_data_email.length > 0 && user_data_email.length > 0 || other_data_email.length > 0 && user_data.length > 0">{{","}}</span>
                        <span v-if="other_data_email.length > 0">{{other_data_email[0].email }}
                        <span v-if="other_data_email.length > 1">,</span>
                        <span v-if="other_data_email.length > 1">{{other_data_email[1].email }} </span>
                        </span>
                        <el-popover v-if="other_data_email.length > 2" placement="bottom"  trigger="hover">
                            <div v-for="(email,index) in other_data_email" :key="index">
                                <span class="fw-500">{{email.email}}</span>

                            </div>
                            <el-button slot="reference" class="pl-0 pr-0 button-back">
                                <div class="fw-500  mt-4px text-center text-secondary">
                                    +{{other_data_email.length - 2}} more
                                </div>
                            </el-button>
                        </el-popover>
                    </div>
                </div>
                <div class="mt-5 fs-14 fw-600"> Are you sure want to send this Report?</div>
                <div class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-cancel-button px-4" @click="hideSelf">Discard</button>
                    <button class="btn new-save-button ml-4 px-4" @click="confirmSubmit">Send</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    props: ["modal_name"],
    data() {
        return {
            user_data: [],
            user_data_email:[],
            other_data_email: []
        }
    },
    methods: {
        hideSelf() {
            this.$emit("cancelSubmit");
            this.$modal.hide(this.modal_name);
        },
        confirmSubmit() {
            this.$modal.hide(this.modal_name);
            this.$emit("callReportData");
        }
    },
    mounted(){
        EventBus.$on("individualData",(value) => {
            this.user_data = value
        })
        EventBus.$on("teamDataEmail",(value) => {
            this.user_data_email = value
        })
        EventBus.$on("otherDataEmail",(value) => {
            this.other_data_email = value
        })
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    }
}
</script>
<style>
.btn-style{
    border: 1px solid #005dae;
    width: 4em;
    border-radius: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/alertModals/ConfirmSubmitCallreport.vue